import Swiper, {FreeMode, Keyboard, Scrollbar} from 'swiper';
Swiper.use([FreeMode, Keyboard, Scrollbar]);

import { gsap } from 'gsap';

export default class InteractiveMap {
	constructor(elm) {
		this.elm = elm;

        this.swiperContainer = this.elm.querySelector('[data-swiper-container]');
		this.scrollbar = this.elm.querySelector('[data-swiper-scrollbar]');

        this.breakpoint = window.matchMedia('(min-width:992px)');
        this.hasHover = window.matchMedia('(hover: hover) and (pointer: fine)');

        this.boundHandleBreakpoint = this.handleBreakpoint.bind(this);
        this.breakpoint.addEventListener('change', this.boundHandleBreakpoint);
        this.handleBreakpoint();

        this.legendWrapper = this.elm.querySelector('[data-legend-wrapper]');
        this.legends = this.elm.querySelectorAll('[data-legend]');

        this.legendLists = this.elm.querySelectorAll('.c-interactive-map-legend__list');

        this.markers = this.elm.querySelectorAll('[data-marker]');
        this.markers.forEach(marker => {
            marker.addEventListener('mouseenter', e => {
                if(this.hasHover.matches) {
                    this.activateLegend(e);
                }
            });
            marker.addEventListener('mouseleave', e => {
                if(this.hasHover.matches) {
                    this.deactivateLegend();
                }
            });
        });

        gsap.from(this.legendLists, {
			opacity: 0,
            y: -10,
            stagger: 0.4,

			duration: 0.6,
			ease: 'power2.inOut',
			scrollTrigger: {
				trigger: this.legendWrapper,
				start: 'top bottom',
			}
		});
	}

    activateLegend(e) {
        this.elm.classList.add('has-active');

        const target = e.target.getAttribute('data-marker');

        const activeMarker = this.elm.querySelector('[data-marker="'+target+'"');
        activeMarker.classList.add('is-active');

        const activeLegend = this.legendWrapper.querySelector('[data-legend="'+target+'"');
        activeLegend.classList.add('is-active');
    }

    deactivateLegend() {
        this.elm.classList.remove('has-active');

        this.legends.forEach(legend => {
            legend.classList.remove('is-active');
        });

        this.markers.forEach(marker => {
            marker.classList.remove('is-active');
        });
    }

	init() {

		this.swiper = new Swiper(this.swiperContainer, {
			init: true,
			threshold: 2,
			slideClass: 'swiper-slide',
            scrollbar: {
                el: this.scrollbar,
                draggable: false,
              },
			slidesPerView: 0.5,
            freeMode: {
                enabled: true,
                momentumBounce: false,
            },
			spaceBetween: 0,
			grabCursor: true,
			touchEventsTarget: 'container',
			speed: 600
		});

	}

    handleBreakpoint() {
        if(this.breakpoint.matches) {
            if(this.swiper) {
                this.swiper.destroy();
            }
        } else {
            this.init();
        }
    }

    destroy() {
        this.breakpoint.removeEventListener('change', this.boundHandleBreakpoint);
	}

}
